import { render } from "./eventType.vue?vue&type=template&id=54eb4dce"
import script from "./eventType.vue?vue&type=script&lang=js"
export * from "./eventType.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibition/eventType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54eb4dce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54eb4dce', __exports__)) {
    console.log('reload')
    api.reload('54eb4dce', __exports__)
  }
  
  module.hot.accept("./eventType.vue?vue&type=template&id=54eb4dce", () => {
    console.log('re-render')
    api.rerender('54eb4dce', render)
  })

}


export default __exports__